import type { SupportSession } from "@src/types/vpn-support-session";
import apiUseCases from "@src/cloud-connect/api";
import { postVPNAcceptSupportSessionDto } from "@src/cloud-connect/api/vpn-manager/vpn-post-accept-support-session";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export const postVPNAcceptSupportSessionUseCase = async (
  payload: postVPNAcceptSupportSessionDto,
): Promise<{
  success: boolean;
  data?: SupportSession;
  error?: { status?: number; data?: { msg?: string }; message?: string };
}> => {
  try {
    const response = await apiUseCases.postVPNAcceptSupportSession(payload);

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    const { message, status, data } = parseAxiosApiError(
      error,
      "Failed to accept support session.",
    );
    return {
      success: false,
      error: {
        status,
        data: data as { msg?: string } | undefined,
        message,
      },
    };
  }
};
